<template>
    <div class="task-list">
      <div  v-for="(task, index) in activeTasks" class="task" :key="index" @click.stop.prevent="editTaskClicked(task)">
        <div class="d-flex gap-5">
            <div @click.stop.prevent="markTaskCompleted(task)" :class="styalizeRadio(task)">
            <CheckIcon :class="styalizeCheck(task)" class="check-icon" />
            </div>          
            <span :class="taskNameClass(task)">{{ task.name }}</span> 
        </div>

        <div class="task-actions-parent">
          <TrashIcon @click.stop.prevent="deleteTaskClicked(task)" class="delete-task"/>
          <div class="task-actions-div">
              <component
            class="action-icon"
            v-for="(action, actionIndex) in JSON.parse(task.actions)"
            :key="actionIndex"
            :is="getIconComponent(action)"
            v-bind="{ name: action.name }"
            @click.prevent.stop="performAction(task, action)"
            />
          </div>
       
        </div>
       
      </div>
      <div v-if="!addingSubTask" @click.prevent="addTaskToGoalExpanded()" class="d-flex gap-5 add-task-div color-primary">
        <PlusIcon/> <span>Add Task</span>
      </div>
      <div v-else class="d-flex flex-direction-column">
          <div class="textarea-background">
            <textarea
              name="task-name"
              placeholder="Task Description."
              v-model="newTaskName"
              rows="2"
            ></textarea>
          </div>
          <div class="d-flex add-task-actions gap-5">
            <button @click.prevent="addTaskToGoalExpanded()" class="secondary add-task-button">Cancel</button>
            <button @click.prevent="addTaskToGoal()" :disabled="creatingTask" class="primary add-task-button">
            <span v-if="creatingTask">
              <LoadingSpinner class="loading-spinner"/>
            </span>
            <span v-else>
              Add Task
            </span>
          </button>
          </div>
      </div>
    </div>
    <EditTaskModal/>
</template>
  
<script>
import { mapGetters } from 'vuex';
import CheckIcon from '@/components/icons/CheckIcon.vue';
import PlusIcon from './icons/PlusIcon.vue';
import TrashIcon from './icons/TrashIcon.vue';
import tasksService from '@/services/tasksService';
import EditTaskModal from './EditTaskModal.vue';
import { showToastWithUndo } from "@/utils/toastHandler"; // Adjust path as needed
import { markRaw } from 'vue';
import LoadingSpinner from '@/components/icons/LoadingSpinner.vue';

export default {
  name: 'TasksList',
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    goal: {
    type: Object, // The expected type of the prop
    required: false, // Optional: Make the prop required
    },
  },
  components: {
    CheckIcon,
    PlusIcon,
    EditTaskModal,
    TrashIcon,
    LoadingSpinner
  },
  computed: {
    ...mapGetters(['actionTypes']),
    activeTasks() {
        return this.tasks.filter(task => !task.date_deleted);
      },
  },
  data() {
    return {
      loadedIcons: {}, // Store the dynamically loaded icons
      addingSubTask: false,
      newTaskName: '',
      creatingTask: false,
    };
  },
  
  emits: ['taskSelected'],
  mounted() {
    // Dynamically import all icons using require.context (Webpack)
    const icons = require.context('@/components/icons', false, /\.vue$/);

    // Load all icons and store them in loadedIcons
    icons.keys().forEach((filePath) => {
      const iconName = filePath.replace('./', '').replace('.vue', '');
      this.loadedIcons[iconName] = markRaw(icons(filePath).default); // Wrap with markRaw
    });

  },
  methods: {
    async deleteTaskClicked(task){
      let taskCopy = {...task};
      const date = new Date();
      taskCopy.date_deleted = date.toISOString().slice(0, 19).replace('T', ' ');
      await this.$store.dispatch('editTask', { showModal: false, task: taskCopy });

      taskCopy.date_deleted = null;
      // Render the custom component inside the toast
      showToastWithUndo({
        message: "Task Deleted!",
        undoFunction: () => this.$store.dispatch('editTask', { showModal: false, task: taskCopy }),
        type: "success",
        timeout: 5000
      });
    },
    editTaskClicked(task){
      this.$store.dispatch('setShowTaskEditModal', true); // Ensure token is loaded when app is initialized
      this.$store.dispatch('setActiveTaskGoalAction', {task: task, action: null, goal: this.goal}); // Ensure token is loaded when app is initialized
    },
    taskNameClass(task){
        let className= "goal-name d-flex align-items-center";
        if(task.date_completed){
          className += " strike";
        }
        return className
    },
    styalizeRadio(task){
      if(task.date_completed){
          return "radio-button-checked";
      }else{
        return "radio-button";
      }
    },
    styalizeCheck(task){
            if(task.date_completed){
                return "check-icon";
            }else{
                return "check-icon-hidden";
            }
    },
    markTaskCompleted(task){
      if(task.date_completed){
        task.date_completed = null;
          }else{
            const now = new Date();
            task.date_completed = now.toISOString().slice(0, 19).replace('T', ' ');  
          }
          tasksService.updateTask({id: task.id, date_completed: task.date_completed});
    }, 
    async addTaskToGoal() {
      this.creatingTask = true;
      await this.$store.dispatch('addTaskToGoal', {name: this.newTaskName, goal: this.goal}); 
      this.addingSubTask = !this.addingSubTask;
      this.newTaskName = '';
      this.creatingTask = false;

    },
    addTaskToGoalExpanded() {
      this.addingSubTask = !this.addingSubTask;
    },
    performAction(task, action) {
      if(action == 'gmail'){
        this.$store.dispatch('setActiveTaskGoalAction', {task: task, action: action, goal: this.goal}); 
        this.$store.dispatch('performAction', {}); 
        this.$store.dispatch('setSliderState', true);
      }
      if(action == 'google_docs'){
        this.$store.dispatch('prelimQuestions', {task: {...task}, action: action, goal: this.goal}); 
      }
      if(action == 'guide'){
        this.$store.dispatch('setActiveTaskGoalAction', {task: task, action: action, goal: this.goal}); 
        this.$store.dispatch('sendMessage', {}); 
        this.$store.dispatch('setSliderState', true);
      }
    },
    getIconComponent(action) {
      if (!action) return null;
      if(!this.actionTypes[action]) return null;
      return this.loadedIcons[this.actionTypes[action].icon];
    },
  },
};
</script>





<style scoped>

.task-actions-div{
  gap: 5px;
  display: flex;
  margin-left: auto;
}
.action-icon{
  margin-left: auto;
  width: 20px;
  height: 20px;
  stroke: var(--white-color);
}
.task-actions-parent{
  display: flex;
  gap: 10px;
  align-items: center;
  flex-grow: 1;
  padding: 0px 10px;
}
.delete-task{
  width: 25px;
  height: 25px;
  color: rgb(194, 194, 194);
  padding-left: 10px;
  display: none;
}
.task:hover .delete-task{
  display: block ;
}
.add-task-actions{
  margin-left: auto
}
.add-task-button{
  width: 90px;
  padding: 5px 10px; 
}
.add-task-div{
  color: var(--primary-color);
  cursor: pointer;
}
.add-task-div svg path{
  stroke: var(--primary-color) !important;

}
.add-task-div:hover svg path{
  stroke: var(--primary-color) !important;
}
.task-list{
    padding: 0px 20px;
    box-sizing: border-box;
}
.goals-label{
    color: #d5d5d5;
    font-weight: 500;
    font-size: 18px;

}


.check-icon{
  stroke: white;
}
.check-icon-hidden{
  display: none;
}
.radio-button:hover .check-icon{
  display: block
}

@media (max-width: 768px) {
  .task-list{
    width: 100%;
    padding: 5px;
  }
}
</style>